import { render, staticRenderFns } from "./ApplicationSubmitErrorComponent.vue?vue&type=template&id=d84a7066&scoped=true"
import script from "./ApplicationSubmitErrorComponent.vue?vue&type=script&lang=ts"
export * from "./ApplicationSubmitErrorComponent.vue?vue&type=script&lang=ts"
import style0 from "./ApplicationSubmitErrorComponent.vue?vue&type=style&index=0&id=d84a7066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84a7066",
  null
  
)

export default component.exports